/* global System */

export default {
  DocumentLibrary: () =>
    System.import(/* webpackChunkName: "DocumentLibrary" */ './index'),
}
